import { FunctionComponent, ReactNode } from 'react';
import { Languages } from '../top-menu/top-menu';

export type Props = {
  language: Languages;
  className?: string;
  children: ReactNode;
  style?: React.CSSProperties | undefined;
};

const H4: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <>
      {window.location.href.indexOf('/' + props.language + '/') !== -1 && (
        <h4 className={props.className} style={props.style}>
          {props.children}
        </h4>
      )}
    </>
  );
};

export default H4;
